import React, { useMemo } from 'react';

import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Typography from '@material-ui/core/Typography';
import MailOutline from '@material-ui/icons/MailOutline';

import { OPPORTUNITY_COCKPIT_MEDIA } from '../../utils';
import {
    bodyStyle,
    columnPrimary,
    columnSecondary,
    contentRow,
    dividerLine,
    emailRow,
    headingStyle,
    linkStyle,
    mailIcon,
    mailboxArt,
    responseStyle,
    root,
    rootBelowLg,
} from './ContactSupportBanner.style';

/** Figma 17556:156534 — Contact / support */
const ContactSupportBanner = ({
    supportEmail = 'support@dsilo.ai',
    heading = 'Need Help or Want to Report an Issue?',
    body = "Contact our team for agent subscriptions, support questions, or to report any issues you're facing.",
    responseLine = 'We will get back to you in minutes.',
}) => {
    const theme = useTheme();
    /** Reserve right padding / art only from `lg` so ~1200px widths are not squeezed */
    const showMailboxArt = useMediaQuery(theme.breakpoints.up('lg'));
    const belowLg = useMediaQuery(theme.breakpoints.down('lg'));
    const rootStyle = useMemo(
        () => (belowLg ? { ...root, ...rootBelowLg } : root),
        [belowLg]
    );

    return (
        <div style={rootStyle}>
            <div style={contentRow(showMailboxArt)}>
                <div style={columnPrimary}>
                    <Typography style={headingStyle}>{heading}</Typography>
                    <Typography style={bodyStyle}>{body}</Typography>
                </div>

                <div style={columnSecondary}>
                    <div style={emailRow}>
                        <MailOutline style={mailIcon} />
                        <Typography component="a" href={`mailto:${supportEmail}`} style={linkStyle}>
                            {supportEmail}
                        </Typography>
                    </div>
                    <div style={dividerLine} />
                    <Typography style={responseStyle}>{responseLine}</Typography>
                </div>
            </div>

            {showMailboxArt ? (
                <img src={OPPORTUNITY_COCKPIT_MEDIA.contactMailboxArt} alt="" style={mailboxArt} />
            ) : null}
        </div>
    );
};

export default ContactSupportBanner;
